import { useEffect, useState, useRef } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import moment from "moment";
import Popup from "../../User/popup";
import { DropDownInput } from "../../components/_input/_dropdown";
import PhoneDropDown from "../../components/_input/_phoneDropDown";
import { TextArea } from "../../components/_input/_textArea";
import { DateInput3 } from "../../components/_input/_dateInput_3";
import { InputField } from "../../components/_input/_input";
import MaintenanceCalendarDialog from "../../components/MaintenanceCalendarDialog";
import { useParams } from "react-router";
import config from '../../configuration/config';
import DatePicker from 'react-datepicker';
import { useHistory, useLocation } from "react-router";
import { GetMessages, formValidate } from '../../utils/validation';
import Joi from "joi";
import { toast } from "react-toastify";
import { UploadControl } from "../../components/_input/_uploadControl";
export function ServiceReservationByID() {

    let { PVIN, PGroupID, PYear, PServiceID } = useParams();
    const PERIODIC_MAINTENANCE_ID = 'EB199B7E-55BE-4AC8-B465-9A110B415CA8';
    const { t: trans, i18n } = useTranslation(["info", "eparts", "common", "global", "offers", "cartFile"]);
    let lang = (i18n.language || 'ar');
    const location = useLocation();
    const query = new URLSearchParams(location.search);
    const [showFinalPopup, setShowFinalPopup] = useState(false);
    const [showCalendar, setShowCalendar] = useState(false);
    const [warningPopup, setWarningPopup] = useState({ show: false, message: '' });
    const popRef = useRef(null);
    const [resOrderID, setResOrderID] = useState(null);
    const history = useHistory();
    const [stepNum, setStepNum] = useState(1);
    const [dataFullNum, setDataFullNum] = useState(0);
    const [VINDetails, setVINDetails] = useState([]);
    const [infoPrice, setinfoPrice] = useState([{ Price: 0 }]);
    const [isSendeng, setIsSendeng] = useState(false);
    const [orderReservation, setOrderReservation] = useState(null);
    const [requestForm, setRequestForm] = useState({
        name: '',
        phone: '',
        email: '',
        subject: '',
        date: '',
        time: '',
        messageContent: '',
        myCarID: '',
        SiteID: null,
        ServiceID: ''
    });
    const [filteredSettings, setFilteredSettings] = useState({
        brands: [],
        groups: [],
        models: [],
        productModels: []
    });


    const [settings, setSettings] = useState({
        brands: [],
        groups: [],
        models: [],
        productModels: []
    });
    const toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
    useEffect(() => {
        FetchOrderReservation();
        FetchInfoService(PServiceID);
    }, [])

    useEffect(() => {

        if (orderReservation) {
            setResOrderID(orderReservation?.MaintenanceOrderID);
            setShowFinalPopup(true);

        }
        fetchSettings();


        if (PVIN)
            GetVINDetails(PVIN);



    }, [PVIN, orderReservation])
    const [firstByLink22, setFirstByLink22] = useState(true);
    useEffect(() => {

        if (PServiceID && settings && settings?.groups?.length > 0 && firstByLink22 == true && Service) {

            setFirstByLink22(false);
            setRequestForm({
                ...requestForm,
                ServiceID: PServiceID
            });

            handleServiceOrder({
                showPopup: true,
                type: "sub2",
                main: Service?.MainService,
                sub1: Service?.subService1,
                sub2: Service?.subService2,
                ServiceID: PServiceID,

            });


        }

    }, [PGroupID, PYear, PServiceID, settings, VINDetails, orderReservation, Service])


    async function GetVINDetails(VIN) {



        const Body = {
            "VIN": VIN
        }

        axios.request({
            url: `${config.controllURL}${lang}/api/Pages/App_GetVINDetails`,
            data: Body, method: "POST", responseType: "json"
        })
            .then(function (response) {
                //console.log("App_GetVINDetails:", response.data);
                setVINDetails(response.data);
            })
            .catch(function (error) {

                //console.log(error);
            });


    }

    useEffect(() => {

        function handleClickOutside(event) {
            if (popRef.current && !popRef.current.contains(event.target) && showFinalPopup === true) {
                setShowFinalPopup(false);
                setResOrderID(null);
                if (location.pathname)
                    history.push(location.pathname);

            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [showFinalPopup]);


    //--------------------------------------------------
    const [maintenanceObj, setMaintenanceObj] = useState({
        showPopup: false, type: "Notset", main: "", sub1: "", sub2: ""
    });
    const [Defult, setDefult] = useState({
        showPopup: false, type: "Notset", main: "", sub1: "", sub2: ""
    });



    const notLoginSchema = Joi.object({
        date: Joi.date().required().messages(GetMessages()),
        time: Joi.date().required().messages(GetMessages()),
        SiteID: Joi.string().required().messages(GetMessages()),
        ServiceID: Joi.string().required().messages(GetMessages()),
        name: Joi.string().required().messages(GetMessages()),
        year: Joi.string().required().messages(GetMessages())
    });



    const [brand, setBrand] = useState((query.get("brandID") && (query.get("brandID") == 1 || query.get("brandID") == 2)) ?? null);
    const [type, setType] = useState(null);
    const [group, setGroup] = useState(null);
    const [vModelCode, setVModelCode] = useState([]);
    const [year, setYear] = useState(null);
    const handleFilteredModels = (option, vYear = year) => {

        setGroup(null);
        setType(null);
        setFilteredSettings({ ...filteredSettings, models: [], productModels: [] });
        setGroup(option);
        var fModels = [];
        try {

            const currentgroupData = settings?.groups?.filter(a => a.brandID == brand && a.productGroupID == option && a.Year == vYear);
            const ListTreeGroups = (currentgroupData && currentgroupData?.length > 0) ? currentgroupData[0].ListTreeGroups : option;

            // Split the comma-separated string into an array
            const listVArray = ListTreeGroups.split(',');

            // Assuming settings.productModels is an array of objects with properties productGroupID and Model
            fModels = settings?.productModels?.filter(a =>
                listVArray.includes(a.productGroupID) && a.Model == vYear
            );
        } catch {

            fModels = settings?.productModels?.filter(a => a.productGroupID == option && a.Model == vYear);
        }





        setFilteredSettings({ ...filteredSettings, productModels: fModels });

    };

    const handelSelectBrand = (option, vYear = year) => {
        setBrand(null);
        setType(null);
        setGroup(null);

        setFilteredSettings({ ...settings, groups: [], models: [], productModels: [] });
        setBrand(option);


        const fGroups = settings?.groups?.filter(a => a.brandID == option && a.Year == vYear);

        setFilteredSettings({ ...settings, groups: fGroups, models: [], productModels: [] });

    };


    useEffect(() => {

        if (settings?.brands && settings?.brands.length > 0 && Defult?.first != true
        ) {
            if (Defult?.year) {
                setYear(Defult?.year)
                const val = { ...requestForm };
                val.year = Defult?.year;
                setRequestForm(val);
            }
            if (Defult?.brand)
                handelSelectBrand(Defult?.brand, Defult?.year);
        }

    }, [Defult, settings]);


    useEffect(() => {

        try {

            if (requestForm?.date) {

                var md = new Date(requestForm?.date);
                try {
                    if (requestForm?.time) {

                        var Hours = requestForm?.time.split(":");

                        md.setHours(Hours[0], Hours[1], 0);
                    }
                } catch (error) {

                }


            }

        } catch (error) {
        }


    }, [requestForm]);

    useEffect(() => {


        if (settings?.brands && settings?.brands.length > 0 && filteredSettings?.groups?.length > 0 && Defult?.first != true) {

            setDefult({ ...Defult, first: true });
            if (Defult?.group)
                handleFilteredModels(Defult?.group);

            if (Defult?.modelType) {
                setType(Defult?.modelType);
            }
        }
    }, [filteredSettings]);
    const FetchInfoService = async (PServiceID) => {


        setinfoPrice([{ Price: 0 }]);
        setLodingService(true);
        const Body = {
            "ServiceID": PServiceID
        }

        axios.request({
            url: `${config.controllURL}${lang}/api/Pages/site_FetchInfoService`,
            data: Body, method: "POST", responseType: "json"
        })
            .then(function (response) {
                setService(response?.data[0]);
                setServiceID(response?.data[0].ServiceID);
                setLodingService(false);
            })
            .catch(function (error) {
                console.log("FetchOrderReservation>>>>", error);
                setLodingService(false);
            });
    };

    const FetchOrderReservation = async () => {
        const Body = {
            "VIN": PVIN,
            "ServiceID": PServiceID
        }

        axios.request({
            url: `${config.controllURL}${lang}/api/Pages/site_FetchOrderReservationByVIN_ServiceID`,
            data: Body, method: "POST", responseType: "json"
        })
            .then(function (response) {
                console.log("FetchOrderReservation>>>>", response.data);
                if (response.data && response.data.length > 0)
                    setOrderReservation(response.data[0]);

            })
            .catch(function (error) {
                console.log("FetchOrderReservation>>>>", error);
            });
    };
    const fetchSettings = async () => {
        try {

            if ("caches" in window) {
                var curl = "Settings-" + lang;

                // Opening that particular cache
                const cacheStorage = await caches.open("HJWeb");

                // Fetching that particular cache data
                const cachedResponse = await cacheStorage.match(
                    curl
                );
                var settingResponseCash = await cachedResponse?.json();
                const currentSettings = {};
                console.log("currentSettings:", currentSettings);
                currentSettings.brands = settingResponseCash?.brands;
                currentSettings.groups = settingResponseCash?.groups;
                currentSettings.models = settingResponseCash?.models;
                currentSettings.productModels = settingResponseCash?.productModels;
                if (currentSettings.brands && currentSettings.groups && currentSettings.productModels) {

                    setSettings(currentSettings);


                    //---------------------------------------------------------------
                    let currentvModelCode = {};
                    currentSettings?.productModels?.map((item) => {
                        if (item.ModelCode) {
                            currentvModelCode[item.productGroupID] = item.ModelCode;
                        }
                    })
                    setVModelCode(currentvModelCode);
                }

            }
        } catch (error) {
            //////console.log(error);
        }
        try {
            const settingResponse = await axios.request({
                baseURL: '/',
                url: config.controllURL + lang + "/api/Maintenance/Settings",
                method: "get"
            });

            const currentSettings = { ...settings };
            currentSettings.brands = settingResponse.data?.brands;
            currentSettings.groups = settingResponse.data?.groups;
            currentSettings.models = settingResponse.data?.models;
            currentSettings.productModels = settingResponse.data?.productModels;

            setSettings(currentSettings);

            //---------------------------------------------------------------

            let currentvModelCode = {};
            currentSettings?.productModels?.map((item) => {
                currentvModelCode[item.productGroupID] = item.ModelCode

            })

            //////console.log("currentvModelCode>>>>>>>>>", currentvModelCode);
            setVModelCode(currentvModelCode);

            const data = new Response(JSON.stringify(settingResponse.data));

            if ("caches" in window) {
                // Opening given cache and putting our data into it
                caches.open("HJWeb").then((cache) => {
                    cache.put("Settings-" + lang, data);

                });
            }

        } catch (error) {
            //////console.log(error);
        }

    };
    const handleServiceOrder = (data) => {

        try {
            data['firstFetchPrice'] = null;
            data['first'] = null;
            setStepNum(1);
            setDataFullNum(0);


            setinfoPrice([{ Price: 0 }]);

            const value = { ...maintenanceObj, ...data };
            if (data?.main == '') {

                data['main'] = null;
            }
            if (data?.sub1 == '') {

                data['sub1'] = null;
            }
            if (data?.sub2 == '') {

                data['sub2'] = null;


            }

            setDefult(data);

            GetBranch();


            setTimeout(() => { setMaintenanceObj(value) }, 2000);


        } catch (e) {
            console.error(e)

        }

    };
    const [Note, setNote] = useState("");

    const [lodingService, setLodingService] = useState(false);

    const [Branches, setBranches] = useState([]);
    let [modelCode, setModelCode] = useState("");
    const [ServiceID, setServiceID] = useState(null);
    const [Service, setService] = useState(null);
    async function FetchPrice(modelC, SID) {

        setinfoPrice([{ Price: 0 }]);
        if (!modelC) {
            return;
        }
        if (!SID) return;



        const Body = {
            "ModelCode": modelC,
            "ServicID": SID
        }

        axios.request({
            url: `${config.controllURL}${lang}/api/Pages/Site_fetchPriceService`,
            data: Body, method: "POST", responseType: "json"
        })
            .then(function (response) {
                // //////console.log(response.data.ApiObjectData);

                setinfoPrice(response.data);

            })
            .catch(function (error) {
                setinfoPrice([{ Price: 0 }]);

                //////console.log(error);
            });


    }

    const checkDataFullNum = async () => {

        if (group && type && ServiceID && requestForm?.date && requestForm?.time && requestForm?.SiteID && requestForm?.name) {

            setDataFullNum(2);
            return 2;
        } else if (group && ServiceID && requestForm?.name) {

            setDataFullNum(1);
            return 2;
        } else {
            setDataFullNum(0);
            return 0;
        }


    }


    const [error, setError] = useState({});
    function SendResreve(VIN, ServecID, UserID, Amount) {


        const val = { ...requestForm };
        val.year = year;
        val.ServiceID = ServiceID;
        setRequestForm(val);
        const result = formValidate(notLoginSchema, val) ?? {};

        setError(result);

        if (Object.keys(result).length == 0 && isSendeng == false) {
            if (orderReservation == null) {

                setIsSendeng(true);
                var myHeaders = new Headers();
                myHeaders.append("Content-Type", "application/json");

                var raw = {
                    "VIN": VIN,
                    "Model": type,
                    "CarType": modelCode,
                    "UserID": UserID ?? "",
                    "Year": year,
                    "TotalAmount": Amount ? Amount : 0,
                    "RequiredServicesList": ServecID,
                    "Note": Note,
                    "MeterReading": requestForm?.meterReading,
                    "FirstName": requestForm?.name,
                    "phone": requestForm?.phone,
                    "StoreID": requestForm?.SiteID,
                    "Orderdate": moment(requestForm?.date).format('YYYY-MM-DD'),
                    "OrderTime": moment(requestForm?.time).format('HH:mm:ss'),
                    "CopyformFile": requestForm?.file
                };


                axios.request({
                    url: config.controllURL + "api/Service/ServiceRequestAdd", headers: myHeaders,
                    data: raw, method: "POST", responseType: "json"
                }).then(function (response) {
                    if (response?.data?.OrderID)
                        setResOrderID(response?.data?.OrderID);
                    setShowFinalPopup(true);
                    toast.success(trans("info:reservation_completed_successfully"));

                }
                ).then((response) => {
                })
                    .catch(error => {
                        setIsSendeng(false);
                    }



                    );


            } else {
                setIsSendeng(true);
                try {
                    axios.put(
                        `${config.controllURL}${lang}/api/Pages/UpdateFleetMaintenanceOrderReservation`,
                        {
                            "Filters": `where GUID = '${orderReservation?.GUID}'`,
                            "Values": {
                                "DateIn": moment(requestForm?.date).format('YYYY-MM-DD') + "T" + moment(requestForm?.time).format('HH:mm:ss')
                            }
                        }
                    ).then(response => {
                        window.location.reload();
                    }).catch(error => {
                        console.log(error);
                        setIsSendeng(false);
                    })
                } catch (err) {
                    console.log('error in deleting the vehicle', err);
                    setIsSendeng(false);
                }
            }
        }
    }



    async function GetBranch() {

        const Body = {};

        await axios.request({
            url: `${config.controllURL}${lang}/api/Pages/site_FetchMaintenanceBranches`,
            data: Body, method: "POST", responseType: "json"
        })
            .then(function (response) {

                setBranches(response.data);


            })
            .catch(function (error) {
                //////console.log(error);
            });


    }

    useEffect(() => {

        if (Branches && Branches?.length > 0 && !requestForm?.SiteID) {

            if (Branches?.length == 1) {
                let val = {};
                val.SiteID = Branches[0]?.SiteID;
                setRequestForm({ ...requestForm, ...val });
            }

        }

    }, [Branches, requestForm]);


    useEffect(() => {
        checkDataFullNum();
    }, [requestForm, ServiceID, year, group, requestForm.SiteID, type]);



    useEffect(() => {
        if (vModelCode != null && ServiceID && Defult?.firstFetchPrice != true) {
            setDefult({ ...Defult, firstFetchPrice: true });
            if (Defult?.modelType) {
                if (vModelCode[Defult?.modelType] && ServiceID)
                    FetchPrice(vModelCode[Defult?.modelType], ServiceID);
            }



        }

    }, [vModelCode, ServiceID]);



    const [listTimeAvailable, setListTimeAvailable] = useState([]);

    const webAvailableReshours = async (date = '', serviceGuid = null) => {
        const Body = {
            "Resdate": date,
            "ServiceGuid": serviceGuid
        }

        await axios.request({
            url: `${config.controllURL}${lang}/api/Pages/web_AvailableReshours`,
            data: Body, method: "POST", responseType: "json"
        })
            .then(function (response) {
                //console.log("web_AvailableReshours:response", response);
                if (response.status >= 200 && response.status < 299) {
                    //console.log("web_AvailableReshours:response", response.statusText);
                    if (response?.data && response?.data.length != 0) {
                        response?.data.forEach((val, index) => {
                            //console.log("ForEach:val", parseInt(val?.AvailableHour));
                            setListTimeAvailable(_lstTime => [..._lstTime, parseInt(val?.AvailableHour)]);
                        });

                    }
                }
            })
            .catch(function (error) {
                //console.log("web_AvailableReshours:Error", error);
                toast.warn(trans("form:please-choose-another-date"));
            });
    }


    return (
        <>

            {/* <div class="reservation-head" >

                <div class="reservation-head-Logo">

                    {
                        lang == "ar" ?

                            <div className="res-Logo-icon ">
                                <img src="/assets/logo/logo_AR.png"
                                    alt="hassan jameel" className="hidden d-md-inline" />
                                <img src="/assets/logo/logo_AR.png"
                                    alt="hassan jameel" className="d-inline d-md-hidden" />
                            </div>


                            :

                            <div className="res-Logo-icon ">
                                <img src="/assets/logo/logo_EN.png"
                                    alt="hassan jameel" className="hidden d-md-inline" />
                                <img src="/assets/logo/logo_EN.png"
                                    alt="hassan jameel" className="d-inline d-md-hidden" />
                            </div>
                    }
                </div>
                <button
                    onClick={() => {

                        if (window.location.href.includes("/ar") || window.location.href.includes("/en")) {

                            if (window.location.href.includes("/en"))
                                window.location = window.location.href.replace("/en", "/ar");
                            if (window.location.href.includes("/ar"))
                                window.location = window.location.href.replace("/ar", "/en");

                        } else {

                            window.location = window.location.origin + "/en" + window.location.pathname;
                        }
                    }}
                    className="reservation-head-Logo-lang h-full  flex justify-center items-center">

                    <span className='text-white text-16 font-bold pl-2 pr-2 capitalize'>{trans('common:changeLang')}</span>
                    <img src="/assets/icons/globle.svg" alt="change language" />
                </button>

            </div >
            <div class="reservation-head-sub">
                {
                    lang == "ar" ?

                        <h1 className="text-balck text-bold text-20 text-center">لعمر افتراضي أطول، حافظ على سيارتك</h1>
                        :
                        <h1 className="text-balck text-bold text-20 text-center">For longer longevity, maintain your vehicle </h1>
                }

            </div> */}

            <div className={"protection-and-shading   " + (brand == 1 ? " toyota-theme " : " lexus-theme ")} >
                <div className="protection-and-shading-head" >
                    <div className="protection-and-shading-head-Logo">

                        {
                            lang == "ar" ?

                                <div className="res-Logo-icon ">
                                    <img src="/assets/logo/logo_font_Black_AR.svg"
                                        alt="hassan jameel" className="hidden d-md-inline" />
                                    <img src="/assets/logo/logo_font_Black_AR.svg"
                                        alt="hassan jameel" className="d-inline d-md-hidden" />
                                </div>


                                :

                                <div className="res-Logo-icon ">
                                    <img src="/assets/logo/logo_font_Black_EN.svg"
                                        alt="hassan jameel" className="hidden d-md-inline" />
                                    <img src="/assets/logo/logo_font_Black_EN.svg"
                                        alt="hassan jameel" className="d-inline d-md-hidden" />
                                </div>
                        }
                    </div>

                    <div className="protection-and-shading-head-extra flex flex-worp">
                        <div className="protection-and-shading-head-brand flex flex-worp">
                            {
                                (brand == 1) ?
                                    <>
                                        <img src={`/assets/icons/brands/${"toyota-logo-withName.png"}`}
                                            className="" alt={brand} />
                                    </>
                                    :
                                    (
                                        (brand == 2) ?
                                            <>
                                                <img src={`/assets/icons/brands/${"lexus-logo-withName.png"}`}
                                                    className="" alt={brand} />
                                            </>
                                            :
                                            null

                                    )

                            }
                        </div>

                        <button
                            onClick={() => {

                                if (window.location.href.includes("/ar") || window.location.href.includes("/en")) {

                                    if (window.location.href.includes("/en"))
                                        window.location = window.location.href.replace("/en", "/ar");
                                    if (window.location.href.includes("/ar"))
                                        window.location = window.location.href.replace("/ar", "/en");

                                } else {

                                    window.location = window.location.origin + "/en" + window.location.pathname;
                                }
                            }}
                            className="protection-and-shading-top-lang h-full  flex justify-center items-center">

                            <span className='text-white font-bold pl-2 pr-2 capitalize'>{trans('common:changeLangCode')}</span>
                            <img src="/assets/icons/globle.svg" alt="change language" />
                        </button>
                    </div>


                </div >
                <div className=" nice-container nice-relative">
                    <div className=" p-4">
                        <div className="mainteance-popup-container-header py-5 flex nice-flex-space-between items-center">
                            <h1 className="text-balck text-bold text-24 text-center">{trans("info:appointment-booking") + " " + trans("global:maintenance")}</h1>


                        </div>

                        <div className="my-8  flex flex-col nice-gap-2rem ">
                            {
                                stepNum == 1 &&
                                <>

                                    {
                                        <>
                                            <div className="flex flex-row grid-2-cols nice-gap-2rem ">

                                                <div className="basis-2/4 grow">

                                                    <InputField
                                                        errorLabel={error?.name}
                                                        placeholder={trans("form:name")}
                                                        value={requestForm.name}
                                                        length={255}
                                                        onChangeValue={
                                                            (e) => {
                                                                const val = {};
                                                                val.name = e.target.value;
                                                                setRequestForm({ ...requestForm, ...val });
                                                            }
                                                        }
                                                    />
                                                </div>

                                                <div className="grow">
                                                    <PhoneDropDown
                                                        title={trans("form:phone")}
                                                        errorLabel={error?.phone}
                                                        value={requestForm.phone}
                                                        onChangeValue={(countryCode, phoneNumber) => {
                                                            const val = { ...requestForm };
                                                            val.phone = phoneNumber ? `+${countryCode}${phoneNumber}` : null;
                                                            val.codephone = `+${countryCode}`;
                                                            setRequestForm(val);
                                                        }}

                                                        defaultValue={requestForm?.phone?.replace(`${requestForm?.codephone}`, '')}
                                                    />
                                                </div>


                                            </div>
                                            <div className="flex flex-row grid-2-cols-importent nice-gap-2rem ">
                                                <div className="basis2/4 grow">
                                                    <DropDownInput

                                                        defaultOption={(brand == '0' || brand == null) ? { text: trans("info:company"), value: '0' } : null}
                                                        options={settings?.brands?.map(item => {
                                                            return { text: item?.description, value: item?.brandID }
                                                        })}
                                                        disabled={(query.get("brandID") == 1 || query.get("brandID") == 2)}
                                                        selectedValue={brand}
                                                        onSelect={handelSelectBrand}

                                                    />

                                                </div>


                                                <div className="basis2/4 grow">
                                                    <DropDownInput
                                                        errorLabel={error?.year}
                                                        defaultOption={{
                                                            text: trans("info:created_year"),
                                                            value: '0'
                                                        }}

                                                        // options={settings?.models?.map(item => {
                                                        //     return { text: item?.modelID, value: item?.modelID }
                                                        // })}

                                                        options={
                                                            settings?.models?.filter(
                                                                item => item?.modelID?.startsWith('20')).map(
                                                                    item => ({
                                                                        text: item?.modelID,
                                                                        value: item?.modelID
                                                                    })
                                                                )
                                                        }

                                                        selectedValue={year}
                                                        onSelect={(value) => {
                                                            //////console.log("models:", value)

                                                            setYear(value);

                                                            const val = {};
                                                            val.year = value;
                                                            setRequestForm({ ...requestForm, ...val });
                                                            handelSelectBrand(brand, value);
                                                        }}
                                                    />

                                                </div>

                                                <div className="basis2/4 grow">
                                                    <DropDownInput
                                                        defaultOption={((brand == '0' || brand == null) || (group == '0' || group == null)) ? {
                                                            text: trans("eparts:vehicle"),
                                                            value: '0'
                                                        } : null}
                                                        options={filteredSettings?.groups?.map(item => {
                                                            return { text: item?.description, value: item?.productGroupID }
                                                        })}
                                                        selectedValue={group}
                                                        onSelect={handleFilteredModels}

                                                    />

                                                </div>


                                                <div className="basis2/4 grow">
                                                    <DropDownInput

                                                        defaultOption={((brand == '0' || brand == null) || (group == '0' || group == null)) ? {
                                                            text: trans("eparts:model"),
                                                            value: '0'
                                                        } : null}
                                                        placeholder={trans("eparts:model")}
                                                        errorLabel={requestForm?.type}
                                                        options={filteredSettings?.productModels?.map(item => {
                                                            return { text: item?.ShortDescriptionEn, value: item?.productTypeID }
                                                        })}
                                                        selectedValue={type}
                                                        onSelect={(value) => {
                                                            setType(value);
                                                            setModelCode(vModelCode[value]);

                                                        }}
                                                    />
                                                </div>

                                            </div>


                                        </>

                                    }
                                </>
                            }

                            {


                                <>
                                    <div className="flex flex-row grid-2-cols-importent nice-gap-2rem ">


                                        {

                                            <InputField
                                                isLoading={lodingService}
                                                disabled={true}
                                                errorLabel={error?.ServiceID}
                                                placeholder={trans("info:servce")}
                                                value={lang === 'ar' ? Service?.ServiceNameAR : Service?.ServiceName}
                                                length={255}
                                                onChangeValue={
                                                    (e) => {
                                                        const val = {};
                                                        val.ServiceID = e.target.value;
                                                        setRequestForm({ ...requestForm, ...val });
                                                    }
                                                }
                                            />
                                        }

                                        <div className="flex flex-row  nice-gap-2rem ">

                                            <DropDownInput
                                                // title={trans("info:branch")}
                                                className={"w-90"}
                                                errorLabel={error?.SiteID}
                                                options={[
                                                    ...Branches.map(B => {
                                                        return { value: B.SiteID, text: lang === 'ar' ? B.DescriptionAr : B.DescriptionEn };
                                                    })]}
                                                selectedValue={Branches?.length == 1 ? Branches[0]?.SiteID : requestForm?.SiteID}
                                                onSelect={(value) => {

                                                    //////console.log("onSelect:", value);
                                                    const val = {};
                                                    val.SiteID = value;
                                                    setRequestForm({ ...requestForm, ...val });
                                                }}


                                            />

                                            <a target="_blank" href="https://maps.app.goo.gl/TYwNm9SseQqA2WZx6" class="contact-tile">
                                                <div class="location-icon">
                                                    <img src="/assets/icons/contact/location.svg" alt="user profile" />
                                                </div>
                                            </a>

                                        </div>
                                    </div>
                                    <div className="flex flex-row grid-2-cols-importent nice-gap-2rem ">


                                        <div className="grow">
                                            <div className="basis-2/4 grow">

                                                <div
                                                    className="w-full flex items-center bg-white border border-gray-200 rounded-lg cursor-pointer hover:border-red-500 transition-all nice-shadow-1"
                                                    style={{ minHeight: '6rem', padding: '0 1.5rem' }}
                                                    onClick={() => setShowCalendar(true)}
                                                >
                                                    <span className="text-2xl opacity-60 flex-grow">
                                                        {requestForm.date ? moment(requestForm.date).format('YYYY-MM-DD') : trans("form:maintenance-date")}
                                                    </span>
                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-red-600">
                                                        <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                                                        <line x1="16" y1="2" x2="16" y2="6"></line>
                                                        <line x1="8" y1="2" x2="8" y2="6"></line>
                                                        <line x1="3" y1="10" x2="21" y2="10"></line>
                                                    </svg>
                                                </div>

                                                <MaintenanceCalendarDialog
                                                    show={showCalendar}
                                                    onClose={() => setShowCalendar(false)}
                                                    selectedDate={requestForm.date}
                                                    subServiceID={Service?.subService1}
                                                    onSelect={async (value) => {
                                                        const val = {};
                                                        val.date = value;
                                                        val.time = null;
                                                        setRequestForm({ ...requestForm, ...val });
                                                        setListTimeAvailable([]);

                                                        const selectedDate = moment(value).format('yyyy-MM-DD');
                                                        const today = moment().format('yyyy-MM-DD');
                                                        const isToday = selectedDate === today;
                                                        const sub1 = Service?.subService1;
                                                        const hasRestricted = sub1?.toUpperCase() !== PERIODIC_MAINTENANCE_ID;

                                                        if (isToday && hasRestricted) {
                                                            setWarningPopup({
                                                                show: true,
                                                                message: lang === 'ar'
                                                                    ? "هذه الخدمة لا يمكن حجزها في نفس اليوم، يرجى اختيار تاريخ آخر (ابتداءً من الغد)."
                                                                    : "This service cannot be booked on same day, please choose another date (starting from tomorrow)."
                                                            });
                                                            return;
                                                        }

                                                        if (val.date) {
                                                            await webAvailableReshours(selectedDate, sub1);
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </div>

                                        <div className="grow">
                                            <div className="basis-2/4 grow">
                                                <DatePicker

                                                    showDisabledMonthNavigation={true}
                                                    includeTimes={listTimeAvailable.map((val) => {
                                                        const time = new Date();
                                                        let res;

                                                        const sub1 = Service?.subService1;
                                                        // Removed local shift limitation as per backend update
                                                        if (requestForm.date && new Date(requestForm.date).toDateString() === new Date().toDateString()) {
                                                            if (val > new Date().getHours()) {
                                                                res = time.setHours(val, 0, 0);
                                                            }
                                                        } else if (requestForm.date && new Date(requestForm.date) > new Date()) {
                                                            res = time.setHours(val, 0, 0);
                                                        } else {
                                                            res = time.setHours(val, 0, 0);
                                                        }

                                                        return res;
                                                    })}


                                                    isClearable={!!requestForm.time}
                                                    selected={requestForm.time}
                                                    onChange={(value) => {

                                                        const val = {};
                                                        val.time = value;
                                                        setRequestForm({ ...requestForm, ...val });

                                                        if (value) {
                                                            const selectedHour = moment(value).hour();
                                                            if ([13, 14, 15].includes(selectedHour)) {
                                                                toast.warn("السيارة سيتم استلامها من قبل المهندس المختص وسيتم اعلامك عزيزي الضيف بوقت الاستلام بعد الانتهاء من أعمال الصيانة");
                                                            }
                                                        }
                                                    }}
                                                    className="w-100"

                                                    placeholderText={trans("form:maintenance-time")}
                                                    showTimeSelect
                                                    showTimeSelectOnly
                                                    timeIntervals={60}
                                                    timeInputLabel={trans("form:maintenance-time")}
                                                    timeCaption={trans("form:maintenance-time")}
                                                    dateFormat="hh:mm aa"
                                                    customInput={<DateInput3 />}

                                                />
                                            </div>
                                        </div>

                                    </div>


                                    <div className="grow input  ">

                                        {/* <ErrorLabel errorTitle={error?.file} /> */}
                                        <UploadControl
                                            placeholder={trans("info:Form_file")}
                                            errorLabel={error?.identificationImage}
                                            modelClasses={" nice-shadow-0   "}
                                            extraClasses={" border-radius-sm  text-24 "}
                                            value={requestForm?.fileName}
                                            onPicker={async (e) => {
                                                const { target } = e;
                                                const { files } = target;
                                                const loadedImage = files[0];

                                                if (loadedImage) {
                                                    if (!loadedImage.type.startsWith("image/")) {
                                                        toast.error(trans('Please select a valid image file!'));
                                                        const val = { ...requestForm };
                                                        val.file = "";
                                                        val.fileName = "";
                                                        setRequestForm(val);

                                                        return;
                                                    }
                                                }
                                                // loadedImage will be a image file.
                                                if (target.value && loadedImage?.name) {
                                                    const size = loadedImage.size;
                                                    const finalCheck = Math.round((size / 1024));
                                                    if (finalCheck >= 4096) {
                                                        toast.error(trans('new:file_size_error'));
                                                        return;
                                                    }

                                                    const val = { ...requestForm };
                                                    val.fileName = loadedImage?.name;
                                                    const fileBase64 = await toBase64(loadedImage);
                                                    const finalFile = fileBase64.substr(fileBase64.indexOf(',') + 1, fileBase64.length);
                                                    val.file = finalFile;
                                                    setRequestForm(val);
                                                } else {
                                                    const val = { ...requestForm };
                                                    val.file = "";
                                                    val.fileName = "";
                                                    setRequestForm(val);
                                                }
                                            }} accept={"image/*"} />
                                    </div>
                                    <TextArea
                                        value={Note}
                                        row={3}
                                        placeholder={trans("info:notes")}
                                        onChangeValue={(data) => {
                                            setNote(data);
                                        }}
                                    />

                                </>

                            }
                        </div>
                        <div className="ruler-2 mb-3"></div>
                        {

                            <>
                                {

                                    <div className="nice-row py5 px-5 nice-flex-center ">
                                        <div className="nice-col-md-6 mb-5">
                                            <div className={"nice-bg-btn  text-white text-24 " + (dataFullNum >= 2 ? " bg-primary " : " bg-gray ")} onClick={() => {



                                                if (dataFullNum >= 2 && isSendeng == false)
                                                    SendResreve(PVIN, ServiceID, VINDetails[0]?.CustID, infoPrice[0].Price);

                                            }}>
                                                {
                                                    (orderReservation) ?
                                                        trans("info:save_changes")
                                                        :
                                                        trans("info:reserve")

                                                }

                                                {
                                                    isSendeng && <span className='mx-2 loading-btn '>
                                                        <img src='/assets/icons/loading.svg' width='25' height='25' />
                                                    </span>
                                                }

                                            </div>
                                        </div>

                                    </div>



                                }

                            </>
                        }


                        <ul class="reservation-privacy-link">
                            {

                                <li className="text-balck text-bold text-24 text-center">
                                    <a className={"text-16"} href="/privacy">{trans('offers:terms')}</a>
                                </li>
                            }

                        </ul>

                    </div>


                </div>

            </div>

            <Popup show={showFinalPopup}>
                <div className="w-full h-full flex flex-column justify-center items-center" >
                    <div className="cart-finalized" >
                        <div className="cart-finalized-container flex flex-col">

                            <div className="cart-finalized-container-img flex flex-col">
                                <img src="/assets/images/finalized.svg" />
                            </div>

                            <div className="flex flex-wrap justify-center">
                                <span className="text-20 font-bold text-black mx-2 unselectable ">{trans("new:thank_to_choose")}</span>
                                <span className="text-20 font-bold text-primary mx-2"> {trans("new:HJ_cars")}</span>
                            </div>

                            {
                                <>
                                    <div className="flex flex-row justify-center mb-10">
                                        <span className="text-20 font-bold  mx-2"> {trans("new:The_appointment_has_been_booked")}</span>
                                    </div>

                                    {filteredSettings?.groups?.filter(s => s.productGroupID == group).length > 0 &&
                                        <div className="flex flex-row justify-center">
                                            <span className="text-20 font-bold text-primary  mx-2">
                                                {filteredSettings?.groups?.filter(s => s.productGroupID == group)[0]?.description}
                                                {` (${year}) `}</span>
                                        </div>
                                    }
                                    {Service &&
                                        <div className="flex flex-row justify-center">
                                            <span className="text-20 font-bold  mx-2"> {trans("info:servce")}: </span>
                                            <span className="text-20 font-bold text-primary  mx-2"> {Service?.ServiceNameAR} </span>
                                        </div>
                                    }

                                    <div className="flex flex-row justify-center">
                                        <span className="text-20 font-bold  mx-2">{trans("form:maintenance-date")}: </span>
                                        <span className="text-20 font-bold text-primary  mx-2"> {orderReservation?.DateIn ?
                                            moment(orderReservation?.DateIn).format('YYYY-MM-DD')
                                            : moment(requestForm?.date).format('YYYY-MM-DD')} </span>
                                    </div>
                                    <div className="flex flex-row justify-center">
                                        <span className="text-20 font-bold  mx-2"> {trans("form:maintenance-time")}: </span>
                                        <span className="text-20 font-bold text-primary  mx-2">
                                            {
                                                orderReservation?.DateIn ? moment(orderReservation?.DateIn).format('hh:mm A')
                                                    : moment(requestForm?.time).format('hh:mm A')} </span>
                                    </div>

                                    {

                                        resOrderID &&
                                        <div className="flex flex-row justify-center cart-finalized-code"
                                            onClick={() => {

                                                navigator.clipboard.writeText(resOrderID);
                                            }}

                                        >

                                            <span className="text-20 font-bold text-white  mx-2"> {trans("new:Reservation_number") + " :"}</span>
                                            <span className="text-20 font-bold text-white  mx-2">{resOrderID && resOrderID}</span>
                                            <img src="/assets/icons/copy.svg" alt='' />
                                        </div>
                                    }

                                </>

                            }
                            <div className="flex flex-center flex-col  mt-5 pt-5 w-80">
                                <div className=" mb-5 w-100">
                                    <div className="nice-sm-btn cart-notification-go  bg-primary text-white text-16" onClick={() => {

                                        setShowFinalPopup(false);
                                        setResOrderID(null);
                                        if (location.pathname)
                                            history.push("/");

                                    }}>
                                        {trans("cartFile:Continue_browsing")}
                                    </div>
                                </div>
                            </div>


                        </div>

                    </div>

                    {

                        orderReservation && orderReservation?.OrderStatusID && orderReservation?.OrderStatusID == "Created" &&


                        <div className="flex flex-center flex-col  mt-5 pt-5 w-80">
                            <div className="nice-sm-btn cart-notification-go  text-white text-16 gap-1" onClick={() => {

                                var threeDaysFromNow = new Date();
                                if (orderReservation?.DateIn)
                                    threeDaysFromNow = new Date(orderReservation?.DateIn);
                                if (orderReservation?.Note)
                                    setNote(orderReservation?.Note);

                                setRequestForm({
                                    ...requestForm,
                                    date: threeDaysFromNow,
                                    time: orderReservation ? threeDaysFromNow : ""
                                });

                                setShowFinalPopup(false);

                            }}>


                                {/* <img src="/assets/icons/edit.svg" width={20} height={20} alt=""></img> */}
                                <svg
                                    id="SvgjsSvg1001"
                                    width="15"
                                    height="15"
                                    xmlns="http://www.w3.org/2000/svg"
                                    version="1.1"
                                    xmlnsXlink="http://www.w3.org/1999/xlink"
                                    xmlnsSvgjs="http://svgjs.com/svgjs"
                                >
                                    <defs id="SvgjsDefs1002"></defs>
                                    <g id="SvgjsG1008" transform="matrix(1,0,0,1,0,0)">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" width="15" height="15">
                                            <path
                                                d="M18.293 31.707h6.414l24-24-6.414-6.414-24 24v6.414zm27.586-24l-3.586 3.586-3.586-3.586 3.586-3.586 3.586 3.586zM20.293 26.121l17-17 3.586 3.586-17 17h-3.586v-3.586z"
                                                fill="#ffffff"
                                                className="color000 svgShape"

                                            ></path>
                                            <path
                                                d="M45.293 19.707h-2v27h-38v-40h28v-5h-38v50h60z"
                                                fill="#ffffff"
                                                className="color000 svgShape"
                                            ></path>
                                        </svg>
                                    </g>
                                </svg>
                                {trans("info:edit") + " " + trans("info:the_appointment")}

                            </div>
                        </div>

                    }
                </div>
            </Popup >
            <Popup show={warningPopup.show}>
                <div className="w-full h-full flex justify-center items-center">
                    <div className="cart-finalized" style={{ minHeight: '200px' }}>
                        <div className="cart-finalized-container flex flex-col p-8">
                            <div className="flex flex-wrap justify-center mb-6">
                                <span className="text-20 font-bold text-black text-center unselectable">{warningPopup.message}</span>
                            </div>
                            <div className="flex flex-center flex-col mt-5 w-80">
                                <div className="mb-5 w-100">
                                    <div className="nice-sm-btn cart-notification-go bg-primary text-white text-16"
                                        onClick={() => setWarningPopup({ show: false, message: '' })}>
                                        {lang === 'ar' ? "موافق" : "OK"}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Popup>
        </>
    );
}